module.exports = __webpack_public_path__ + "crm_static/img/12.b91f0250.png";